import { Activity, Bot, FileText, Clock } from 'lucide-react';
import { LogStats as LogStatsType } from '../../types';

interface LogStatsProps {
  stats: LogStatsType;
}

export function LogStats({ stats }: LogStatsProps) {
  const topAgents = Object.entries(stats.byAgent)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 5);

  const operationPercentages = Object.entries(stats.byOperation).map(
    ([op, count]) => ({
      operation: op,
      count,
      percentage: stats.total > 0 ? Math.round((count / stats.total) * 100) : 0,
    })
  );

  return (
    <div className="bg-white border rounded-lg p-4">
      <h3 className="font-semibold text-gray-900 mb-4">Statistics</h3>

      <div className="grid grid-cols-3 gap-4">
        {/* Total operations */}
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex items-center gap-2 text-gray-500 mb-2">
            <Activity className="w-4 h-4" />
            <span className="text-sm">Total Operations</span>
          </div>
          <p className="text-2xl font-bold text-gray-900">
            {stats.total.toLocaleString()}
          </p>
          <p className="text-sm text-gray-500">today: {stats.today}</p>
        </div>

        {/* By agent */}
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex items-center gap-2 text-gray-500 mb-2">
            <Bot className="w-4 h-4" />
            <span className="text-sm">By Agent</span>
          </div>
          <div className="space-y-1">
            {topAgents.map(([agent, count]) => (
              <div
                key={agent}
                className="flex items-center justify-between text-sm"
              >
                <span className="truncate text-gray-600">
                  {agent.split('-')[0]}
                </span>
                <span className="font-medium">{count}</span>
              </div>
            ))}
          </div>
        </div>

        {/* By operation */}
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex items-center gap-2 text-gray-500 mb-2">
            <FileText className="w-4 h-4" />
            <span className="text-sm">By Operation</span>
          </div>
          <div className="space-y-1">
            {operationPercentages.map(({ operation, percentage }) => (
              <div
                key={operation}
                className="flex items-center justify-between text-sm"
              >
                <span className="text-gray-600">
                  {operation.replace('_', ' ')}
                </span>
                <span className="font-medium">{percentage}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
